<template>
    <div class="BugReportDialogue" @click="toggleBugReport()">
        <div class="br-container" @click="$event.stopPropagation()"><!--stopPropagation so toggleSharing() wont trigger on dialogue itself -->
            
            <!-- Title -->
            <h1 class="br-header">Melde ein Problem</h1>      

            <!-- Zusammenfassung -->
            <h2 class="br-subheader">Fasse bitte das Problem für uns zusammen:</h2>
            <textarea id="br-summary" class="br-textarea" name=""/>

            <!-- Schritte -->
            <h2 class="br-subheader">Welche Schritte führen zum Problem:</h2>
            <textarea id="br-repro" class="br-textarea" name=""/>


            <div class="br-testing" v-show="qualityTest == null || connectionTest == null">{{ $t('Ihre Verbindung wird überprüft') }}...</div>
            <md-button class="br-send" @click="send();">Senden</md-button>  
            
            <!-- Version -->
            <p class="br-version">Flux360 Version: {{appVersion}}</p>
        </div>
    </div>
</template>

<style scoped>
    .BugReportDialogue{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        background: #000000d0;
    }
    .br-container{
        background: white;
        padding: 30px;
        border-radius: 10px;
    }
    .br-header{
        text-align: center;
        font-size: 30px;
        margin-bottom: 40px;
    }
    .br-subheader{
        font-size: 18px;
    }
    .br-textarea{
        width: 600px;
        height: 100px;
        font-family: var(--primaryFont), Helvetica, Arial, sans-serif;
        border-color: var(--primaryColor);
        font-size: 15px;
        border-radius: 5px;
        resize: none;
        outline: none;
        padding: 10px;
        box-sizing: border-box;
    }
    .br-testing{
        text-align: right;
        animation: pulse 2s infinite ease-in-out;
    }
    .br-send{
        margin-left: calc(100% - 92px);
        background: var(--primaryColor);
        color: white !important;
    }
    .br-version{
        text-align: center;
        margin-top: 30px;
    }
    @keyframes pulse {
        0% {
            color: #000000;
        }
        50% {
            color: #888888;
        }
        100% {
            color: #050505;
        }
    }
     @media (max-device-width: 900px){
        .br-screen{
            z-index: 99;
        }
        .br-container{
            width: 95%;
            padding: 10px;
        }
        .br-textarea{
            width: 100%;
        }
     }
</style>
    
<script>
import {mapState, mapGetters} from 'vuex';
import * as RaumtaenzerApi from "@/api/raumtaenzer";
import OT from "@opentok/client";

const NetworkTest = require('opentok-network-test-js').default;

export default {
    name: 'bug-report-dialogue',
    inject: ['toggleBugReport'],
    data: () => ({
        test: null,
        qualityTest: null,
        qualityResult: null,
        qualityError: null,
        connectionTest: null,
        connectionResult: null,
        connectionError: null,
    }),
    computed: {
        ...mapGetters(['localUser','appVersion']),
    },
    mounted: function(){
        this.testOpenTok();
    },
    methods: {
        //Source: https://github.com/opentok/opentok-network-test-js
        async testOpenTok() {
            var self = this;
            const data = {
                user_id: this.localUser.id,
                user_name: this.localUser.getName(),
                role: this.selectedTab,
                room_id: this.localUser.id + "_test"
            };
            const accessToken = "test";
            const result = await RaumtaenzerApi.getVideoSessionInfoForRoom(accessToken, data);
            this.test = new NetworkTest(OT, {
                    apiKey: result.api_key, // Add the API key for your OpenTok project here.
                    sessionId: result.session_id, // Add a test session ID for that project
                    token: result.access_token // Add a token for that session here
                },
                {
                    timeout: 5000,
                    audioSource: this.audioDeviceId,
                    videoSource: this.videoDeviceId,
                }
            );
            self.test.testConnectivity().then((results) => {
                //Connection test success
                self.connectionResult = results;
                self.connectionTest = "success";

                self.test.testQuality(function updateCallback(stats) {}).then((results) => {
                //Quality test success
                self.qualityResult = results;
                self.qualityTest = "success";
                
                }).catch((error) => {
                //Quality test failed
                self.qualityError = error;
                self.qualityTest = "failed";
                });
            }).catch(function (error) {
                //Connection test failed
                self.connectionError = error;
                self.connectionTest = "failed";
                self.qualityTest = "failed";
            });
        },
        send(){
            let subject = "Bug Report Flux 360";
            let bugsummary = document.getElementById("br-summary").value;
            let bugRepro = document.getElementById("br-repro").value;
            document.getElementById("br-summary").value = "";
            document.getElementById("br-repro").value = "";

            let browser = this.getBrowser();
            let screenSize = window.screen.width+" x "+window.screen.height;
            let viewportSize = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)+" x "+ Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
            let os = this.getOS();
            let onMobile = this.checkIfOnMobile();

            let quality = "QualityTest wurde nicht komplett durchgeführt! %0D%0A";
            if(this.qualityTest){
                quality = "QualityTest war erfolgreich! %0D%0A %0D%0A";
                if(this.qualityTest == 'success'){
                    let audioQuality;
                    if(this.qualityResult.audio.supported)
                        audioQuality ="Quality: "+ this.qualityResult.audio.mos.toFixed(1)+" /4.5 %0D%0A"
                                        +"Bitrate: " +this.qualityResult.audio.bitrate.toFixed(0)+" kbs %0D%0A"
                                        +"Paket Verlustrate: "+this.qualityResult.audio.packetLossRatio.toFixed(2)+" % %0D%0A"
                    else
                        audioQuality = "AudioQualitaetsTest Fehler! Grund: "+this.qualityResult.audio.reason;

                    let videoQuality;
                    if(this.qualityResult.video.supported)
                        videoQuality ="Quality: "+ this.qualityResult.video.mos.toFixed(1)+" /4.5 %0D%0A"
                                        +"Bitrate: " +this.qualityResult.video.bitrate.toFixed(0)+" kbs %0D%0A"
                                        +"Framerate: " + this.qualityResult.video.frameRate.toFixed(0) +" fps %0D%0A"
                                        +"Paket Verlustrate: "+this.qualityResult.video.packetLossRatio.toFixed(2)+" % %0D%0A"
                    else
                        videoQuality = "VideoQualitaetsTest Fehler! Grund: "+this.qualityResult.video.reason;

                    quality += "Video %0D%0A"
                                +videoQuality
                                +"%0D%0A"
                                +"Audio %0D%0A"
                                +audioQuality;
                }else{
                    quality = "QualityTest war NICHT erfolgreich! %0D%0A"
                                +"Fehler bei Qualitaetstest: %0D%0A"
                                +this.qualityError;
                }
            }

            let connection = "ConnectionTest wurde nicht komplett durchgeführt! %0D%0A";
            if(this.connectionTest){
                connection = "ConnectionTest war erfolgreich! %0D%0A";
                if(this.connectionResult.failedTests){
                    if(this.connectionResult.failedTests.length != 0)
                    connection+="Dennoch aufgetretene Fehler: %0D%0A";
                    for (let i = 0; i < this.connectionResult.failedTests.length; i++) 
                        connection+= this.connectionResult.failedTests[i].error.message +"%0D%0A";                  
                }
                
                if(this.connectionTest == "failed"){
                    connection = "ConnectionTest war NICHT erfolgreich! %0D%0A"+
                                        "Aufgetretene Fehler: %0D%0A";
                    for (let i = 0; i < this.connectionResult.failedTests.length; i++) 
                        connection+= this.connectionResult.failedTests[i].error.message +"%0D%0A";                  
                    
                }
            }

            let consoleLog = "Console Logs: %0D%0A";
            for (let i = 0; i < console.logs.length; i++) 
               consoleLog+= console.logs[console.logs.length-i-1]+" %0D%0A";

            let body = "Bug Zusammenfassung:%0D%0A"
                        +bugsummary+"%0D%0A"
                        +"%0D%0A"
                        +"Reproduktionsschritte:%0D%0A"
                        +bugRepro+"%0D%0A"
                        +"%0D%0A"
                        +"Browser: "+browser+"%0D%0A"
                        +"Screen Size: "+screenSize+"%0D%0A"
                        +"Viewport Size: "+viewportSize+"%0D%0A"
                        +"Betriebssystem: "+os+"%0D%0A"
                        +"Mobile Browser? "+onMobile+"%0D%0A"
                        +"%0D%0A"
                        +connection + "%0D%0A"
                        +quality +  "%0D%0A"
                        +"%0D%0A"
                        +consoleLog;

            if(body.length > 1600)
                body = body.substring(0,1600);

            window.open("mailto:bugreport@raumtaenzer.com?subject="+subject+"&body="+body);
           
            this.toggleBugReport();
        },
        getBrowser() {
            var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
            if(/trident/i.test(M[1])){
                tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
                return {name:'IE',version:(tem[1]||'')};
                }   
            if(M[1]==='Chrome'){
                tem=ua.match(/\bOPR|Edge\/(\d+)/)
                if(tem!=null)   {return {name:'Opera', version:tem[1]};}
                }   
            M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
            if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
            return M[0]+" "+M[1];
        },
        getOS(){
            var OSName = "Unknown";
            if (window.navigator.userAgent.indexOf("Windows NT 10.0")!= -1) OSName="Windows 10";
            if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSName="Windows 8";
            if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSName="Windows 7";
            if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSName="Windows Vista";
            if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSName="Windows XP";
            if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSName="Windows 2000";
            if (window.navigator.userAgent.indexOf("Mac")            != -1) OSName="Mac/iOS";
            if (window.navigator.userAgent.indexOf("X11")            != -1) OSName="UNIX";
            if (window.navigator.userAgent.indexOf("Linux")          != -1) OSName="Linux";
            return OSName;
        },
        checkIfOnMobile(){
            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        }
    },
}
</script>